import { createContext, useContext, useMemo, useState } from "react";

const ContactFormContext = createContext(null);

export const ContactFormProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const value = useMemo(
    () => ({
      open,
      openForm: () => setOpen(true),
      closeForm: () => setOpen(false),
    }),
    [open],
  );
  return <ContactFormContext.Provider value={value}>{children}</ContactFormContext.Provider>;
};

export const useContactForm = () => useContext(ContactFormContext);
